// 本地存储模块
// 获取
export const getItem = (name, value) => {
    // 未经处理的请求数据
    const data = window.localStorage.getItem(name)
    try {
        // 将data转为js对象
        return JSON.parse(data)
    } catch (error) {
        return data
    }

}
// 存储
export const setItem = (name, value) => {
    // 如果value是对象，把value转为json字符串存储
    if (typeof value === 'object') {
        value = JSON.stringify(value)
    }
    window.localStorage.setItem(name, value)
}
// 删除
export const removeItem = name => {
    window.localStorage.removeItem(name)
}
